import Vue from 'vue'

//Element 组件
import Element from 'element-ui'
import './element-variables.scss'
Vue.use(Element)

import '@/assets/iconfont/iconfont.css'

//svg组件
import SvgIcon from '@/components/SvgIcon'
// 注册到全局
Vue.component(SvgIcon.name, SvgIcon)

//复制黏贴组件  this.$copyText(this.message).then(()=>{console.log('复制成功')},(e)=>{console.log(e)})
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import AudioPlay from '@/components/AudioPlay.vue';

Vue.component(AudioPlay.name, AudioPlay)


//websocket链接
import ws from '@/utils/ws.js';

Vue.prototype.$ws = ws